<mat-toolbar class="ca-toolbar justify-between" [class.pointer-events-none]="!authService.authorizationDone()">
    <div class="flex items-center">
        <div class="hidden sm:flex gap-1 app-name">
            <button mat-icon-button (click)="toggleSidenav.emit()">
                <mat-icon>menu</mat-icon>
            </button>
            <dsw-viessmann-logo class="mt-[2px] cursor-pointer" color="white" routerLink="/start"></dsw-viessmann-logo>
            <span>･</span>
            <span data-testid="app-title">{{ 'PTC.APP_NAME' | translate }}</span>
        </div>
    </div>
    <div class="flex items-center">
        @if (authService.authenticated()) {
            <app-language-switcher></app-language-switcher>
        }
        <dsw-support-link data-testid="global-login-support-link"></dsw-support-link>
        @if (authService.appSwitcherContent(); as appSwitcherContent) {
            <dsw-app-switcher
                data-testid="global-login-app-switcher"
                [appSwitcherContent]="appSwitcherContent"
                locale="en-DE"
            ></dsw-app-switcher>
        }
        <dsw-login
            data-testid="global-login-button"
            [isLoggedIn]="authService.authenticated()"
            [authenticating]="authService.authenticating()"
            (logoutEvent)="logout()"
        ></dsw-login>
    </div>
</mat-toolbar>
